export const JOURNEY_ID = 'journeyId';
export const MIXPANEL_TRACKING = 'woop_mp_tracking';
